import type { DiscountReasonCode } from '@salonomy/types';

/**
 * Human labels for the till's discount-reason picker (WS9 §3). The codes are the canonical reportable
 * set from @salonomy/types — this is presentation only; the reason a discount carries is always one of
 * these codes (no silent overrides — brief non-negotiable). `other` always requires a free-text note,
 * enforced by the form and re-validated by the API.
 */
export const DISCOUNT_REASON_LABELS: Record<DiscountReasonCode, string> = {
  loyalty: 'Loyalty',
  // WS-13 Feature 3b — the recurring-membership benefit. SYSTEM-applied (the till applies it automatically
  // while a client_membership is active), so it carries a label for any report/receipt row but is NOT a
  // manual choice in the picker — it is deliberately absent from DISCOUNT_REASON_ORDER below.
  membership: 'Membership benefit',
  goodwill: 'Goodwill',
  staff_friends_family: 'Staff / friends & family',
  price_match: 'Price match',
  manager_comp: 'Manager comp',
  promotion: 'Promotion',
  first_visit: 'First visit',
  student: 'Student',
  senior: 'Senior',
  other: 'Other (note required)',
};

/** The order the picker offers them in (the small, reportable set the brief asks for). */
export const DISCOUNT_REASON_ORDER: DiscountReasonCode[] = [
  'loyalty',
  'goodwill',
  'staff_friends_family',
  'price_match',
  'manager_comp',
  'promotion',
  'first_visit',
  'student',
  'senior',
  'other',
];
